import { cn } from '../../lib/utils';

// BASE class string — locked by D4
const BASE = 'block truncate text-[10px] leading-[1.2] text-dawn-black';

export interface TruncatedCellTextProps {
  /** The text to render and truncate */
  text: string;
  /** data-testid forwarded to the root <span> */
  'data-testid'?: string;
  /** Additional className merged AFTER BASE via cn(BASE, className) */
  className?: string;
}

export function TruncatedCellText({
  text,
  'data-testid': testId,
  className,
}: TruncatedCellTextProps) {
  return (
    <span data-testid={testId} title={text} className={cn(BASE, className)}>
      {text}
    </span>
  );
}

TruncatedCellText.displayName = 'TruncatedCellText';
